import { DonutChart } from "@carbon/charts-react";
import React, { useEffect, useState } from "react";
import { baseColors } from "../../../../../utils/handlers";
import { formatToIndianRupees } from "../../../../../utils/handlers";

function UsersInflow({ data, inflow }) {
  const [graphData2, setGraphData2] = useState([]);

  const mapGraphData = (data) => {
    const res = data?.slice(0, 5).map((item, index) => {
      return {
        group: item.category,
        value: item.amount,
      };
    });

    setGraphData2(res);
  };
  const [colorMap, setColorMap] = useState({});
  const getColorCycle = (dataLength) => {
    const colors = [];
    for (let i = 0; i < dataLength; i++) {
      colors.push(baseColors[i % baseColors.length]); // Cycle through base colors
    }
    return colors;
  };
  const options = {
    title: null,
    toolbar: false,
    tooltip: {
      valueFormatter: (tooltipValue, label) =>
        `${formatToIndianRupees(tooltipValue)}`,
    },
    legend: {
      enabled: true,
      alignment: "center",
    },

    color: {
      scale: colorMap,
      getFillColor: (dataPoint) => colorMap[dataPoint.group],
    },

    resizable: true,
    donut: {
      center: {
        labels: {
          enabled: false,
        },
        enabled: false,
        numberFormatter: (value) => "",
      },
      alignment: "center",
    },
    pie: {
      labels: {
        formatter: () => void 0,
        enabled: false,
      },
    },
    height: "260px",
  };
  useEffect(() => {
    if (graphData2?.length > 0) {
      const newColorMap = {};
      const colorCycle = getColorCycle(graphData2.length);
      graphData2.forEach((item, index) => {
        newColorMap[item.group] = colorCycle[index];
      });
      setColorMap(newColorMap);
    }
  }, [graphData2]);

  useEffect(() => {
    mapGraphData(data);
  }, []);
  return (
    <div className=" w-[49.5%] rounded-lg border border-[#e6ebed] h-[347px]   ">
      <div className=" w-full mx-4 justify-between mt-4">
        <p className=" text-[#212b36] font-semibold text-base">
          {" "}
          Top 5 Uses- {inflow ? "Inflow" : "Outflow"} %
        </p>
        <div className=" w-full h-full mt-4 px-1">
          <DonutChart data={graphData2} options={options}></DonutChart>
        </div>
      </div>
    </div>
  );
}

export default UsersInflow;
